import React from "react";
import "./footer.styles.scss";
function Footer() {
  return <footer>Footer</footer>;
}

export default Footer;
